import FizConfig from "../FizConfig.js";
import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import $ from "../$.js";

export {init,clear}
Html.registerWidget('widget/media-selector',{init:init,destroy:clear})

class MediaSelected{
  constructor(metaId,url,canDelete){
    this.metaId = metaId;
    this.url = url;
    this.canDelete = canDelete;
  }
}
class MediaSelection{
  constructor(){
    this.array = [];
  }
  add(metaId,url,canDelete){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(item.metaId===metaId){
        return false;
      }
    }
    this.array.push(new MediaSelected(metaId,url,canDelete));
  }
  remove(metaId,url){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(item.metaId===metaId){
        this.array.splice(i,1);
        return true;
      }
    }
    return false;
  }
  contains(metaId,url){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(item.metaId===metaId){
        return true;
      }
    }
    return false;
  }
  size(){
    return this.array.length;
  }
  canDeleteAll(){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(!item.canDelete){
        return false;
      }
    }
    return true;
  }
  deleteAble(){
    return this.array.filter(it=>it.canDelete)
  }
  clear(){
    this.array = [];
  }
  onePicDownloadUrl(){
    if(this.array.length===1){
      return this.array[0].url;
    }
  }
}
export const selection = new MediaSelection();
var
  panel;


function clear(){
  if(selection.size()>0){
    selection.clear();
    $('.media-selected').removeClass('media-selected');
    updateUI();
  }
  
}

function selectiondeleteonclick(evt){
  evt.stopPropagation()
  selectiondelete()
}  
async function selectiondelete(){
  if(!await modal.confirmDelete({
      title:"photos.confirmdeletetitle",
      message:selection.canDeleteAll()? 'photos.confirmdelete':'photos.confirmdeletenotadmin',
      no:"actions.cancel"
    })
  ){
    return;
  }
  var 
    deleteAbleMetaId = selection.deleteAble().map(o=>o.metaId),
    count = deleteAbleMetaId.length;
  
  if(count>0){
    ApiServer.metadelete(deleteAbleMetaId).then(()=>{
      modal.toastDone('photos.toastdeleted',count)
    })
    clear();
    amplify.publish('newActivity');
  }else{
    clear();
  }
}
function selectiondownload(){
  var length = selection.size();
  if(length){
    var onePicDownloadUrl = selection.onePicDownloadUrl();
    if(onePicDownloadUrl){
      window.location = onePicDownloadUrl+"download";
    }else{
      
      //using fetch does not work because of cors
      //and we do not want to g=fetch, we want the browser to download
      document.body.insertAdjacentHTML('beforeend',`<form id='multipledownload' action='${FizConfig.API_BASE_URL}mediadownload' method='post'>
        <input type='submit'>
        ${selection.array.map(o=>`
          <input type='hidden' name='id' value='${decodeURIComponent(o.metaId)}'>`
        ).join('')}
      </form>`)

      var form = document.querySelector('#multipledownload')
      form.submit()
      document.body.removeChild(form);
      
    }
  }
  clear();
}
Html.register({
  selectiondelete,
  selectiondownload
})

async function updateUI(){
  var length = selection.size();
  if(length){
    if(!panel){
      panel = await modal.toast({
        emoji:'🖼️',
        button:[
          {title:'actions.download',onclick:selectiondownload},
          {title:'actions.delete',onclick:selectiondeleteonclick},
        ]
      },0);
      panel.closed.then(clear);
    }
    panel.node.find('flexauto').html(i18n.get(length>1?'mediaselector.selectedN':'mediaselector.selected1',length)) ;
    
    $(document.body).addClass('media-selector-active')
    
  }else{
    panel.close()
    panel = undefined;
    $(document.body).removeClass('media-selector-active')
  }
}

function onClick(evt){
  var 
    node = $(this),
    mediaNode = node.metaIdNode();
  evt.preventDefault();
  evt.stopPropagation();
  if(node.hasClass('media-selected')){
    node.removeClass('media-selected');
    selection.remove(mediaNode.metaId(),mediaNode.attr("href"));
  }else{
    node.addClass('media-selected');
    selection.add(mediaNode.metaId(),mediaNode.attr("href"),mediaNode.attr('data-fw-canDelete')==='true');
  }
  updateUI();
}



amplify.subscribe("sessionExpired pageUnload",clear);

function init(mediaSelector){
  if(selection.contains(mediaSelector.metaId(),mediaSelector.parent().attr("href"))){
    mediaSelector.addClass('media-selected');
  }
  mediaSelector.on('click',onClick)
}